const state = {
    shopCartNum: 0,
    currentAddress: {
      id: '',
      receiver: '',
      mobile: '',
      isDefault: '',
      province: '',
      city: '',
      area: '',
      alias: '',
      address: ''
    },
    editAddress: {},
    swiperIndex: 0,
    typeId: '',
    categoryList: [],
    slideBarShowFlag: false,
    goodsDetail: {},
    goodsComment: '',
    isIpx:false,
    hotelCode: {},
    keepAlive:[],
    shopcartNum:-1
    
  
  }
  export default state
  


// WEBPACK FOOTER //
// ./src/store/state.js